import { render, staticRenderFns } from "./noteSta.vue?vue&type=template&id=fdd0eba2&scoped=true&"
import script from "./noteSta.vue?vue&type=script&lang=js&"
export * from "./noteSta.vue?vue&type=script&lang=js&"
import style0 from "./noteSta.vue?vue&type=style&index=0&id=fdd0eba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0eba2",
  null
  
)

export default component.exports